import { useRef, useState, useEffect } from "react";

export function useThrottle<T>(value: T, interval = 500): T {
  const [throttledValue, setThrottledValue] = useState<T>(value);
  const lastExecuted = useRef<number>(Date.now());

  const timerId = setTimeout(() => {
    lastExecuted.current = Date.now();
    setThrottledValue(value);
  }, interval);

  useEffect(() => {
    if (Date.now() >= lastExecuted.current + interval) {
      lastExecuted.current = Date.now();
      setThrottledValue(value);
    } else {
      return () => clearTimeout(timerId);
    }

    return;
  }, [value, interval]);

  return throttledValue;
}
